import React, { useEffect, useState, useCallback } from 'react';
import { Icon } from '@chatui/core';
import { AudioPlayingLoader } from '../../Loader';
import './style.css';
import { MessageId } from '@chatui/core/lib/components/Message';

interface TextMessageProps {
  messageId: MessageId;
  text: string;
  audio?: string;
  audioPlayingId: MessageId;
  onPlay: () => void;
}

const TextMessage = (props: TextMessageProps) => {
  const { messageId, text, audio, audioPlayingId, onPlay } = props;
  const audioRef = React.useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  const makeURLsClickable = useCallback((str: string) => {
    var urlRegex = /(https?:\/\/\S+(?<![,.;:?!]))/g;
    return str.replace(urlRegex, (url) => {
      return '<a href="' + url + '" target="_blank">' + url + '</a>';
    });
  }, []);

  useEffect(() => {
    if (audioPlayingId !== messageId && audioRef.current && isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  }, [audioPlayingId, audioRef, isPlaying, messageId]);

  const onClick = () => {
    if (!audio || !audioRef.current) return;

    if (
      audioRef.current.paused ||
      audioRef.current.ended ||
      audioRef.current.currentTime === 0
    ) {
      audioRef.current.play();
      onPlay();
    } else {
      audioRef.current.pause();
    }
  };

  return (
    <div onClick={onClick} className="text-message">
      {audio && (
        <span>
          <audio
            src={audio}
            ref={audioRef}
            onPlay={() => setIsPlaying(true)}
            onPause={() => {
              setIsPlaying(false);
            }}
            onEnded={() => {
              setIsPlaying(false);
            }}
          />

          {isPlaying ? (
            <div className="playing-icon">
              <AudioPlayingLoader />
            </div>
          ) : (
            <Icon type="bullhorn" />
          )}
        </span>
      )}

      <span dangerouslySetInnerHTML={{ __html: makeURLsClickable(text) }} />
    </div>
  );
};

export default TextMessage;
